<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24">
    <g transform="translate(0, 0)">
      <line
        data-color="color-2"
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        x1="12"
        y1="14"
        x2="12"
        y2="18"
        stroke-linejoin="miter" />
      <line
        data-color="color-2"
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        x1="8"
        y1="14"
        x2="8"
        y2="18"
        stroke-linejoin="miter" />
      <line
        data-color="color-2"
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        x1="16"
        y1="14"
        x2="16"
        y2="18"
        stroke-linejoin="miter" />
      <polyline
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        points="20,9 20,23 4,23
4,9 "
        stroke-linejoin="miter" />
      <path
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        d="M1,9c0-2.209,1.791-4,4-4
h14c2.209,0,4,1.791,4,4H1z"
        stroke-linejoin="miter" />
      <path
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        d="M8,5L8,5
c0-2.209,1.791-4,4-4h0c2.209,0,4,1.791,4,4v0"
        stroke-linejoin="miter" />
    </g>
  </svg>
</template>
